export enum PopperType {
  DROPDOWN = "dropdown",
  MENU = "menu",
  TOOLTIP = "tooltip",
}

export type GlobalPopperTrigger = HTMLElement & {
  __activatePopper?: () => void;
  __showPopper?: () => void;
};
